import { render, staticRenderFns } from "./location-icon.vue?vue&type=template&id=487099c8&functional=true&"
import script from "./location-icon.vue?vue&type=script&lang=js&"
export * from "./location-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports